/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getOnboardingSuggestedStarterPacks.defs.js'
export { main as default } from './getOnboardingSuggestedStarterPacks.defs.js'
